// Los íconos de menú vienen de Firestore/route meta como "fas fa-x fa-fw";
// se reescribe el prefijo de estilo a Sharp Solid (identidad GTR) sin tocar
// los datos guardados.
const STYLE_PREFIX_MAP: Record<string, string> = {
  fas: "fa-sharp fa-solid",
  far: "fa-sharp fa-regular",
  fal: "fa-sharp fa-light",
  fab: "fa-brands",
};

export function sharpIcon(iconClass: string): string {
  if (!iconClass) return iconClass;
  const tokens = iconClass.trim().split(/\s+/);
  if (tokens.length && STYLE_PREFIX_MAP[tokens[0]]) {
    tokens[0] = STYLE_PREFIX_MAP[tokens[0]];
  }
  return tokens.join(" ");
}
